import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "table-header-item-count" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_TableHeader = _resolveComponent("TableHeader")!
  const _component_TextHighlights = _resolveComponent("TextHighlights")!
  const _component_v_data_table_server = _resolveComponent("v-data-table-server")!
  const _component_v_infinite_scroll = _resolveComponent("v-infinite-scroll")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, { class: "pt-8 mb-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { class: "pl-7" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                class: "pt-2",
                sm: "8"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    onClick: _ctx.startVetpointImport
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('vetpointdaten.import.button')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  (_ctx.vetdataLog.anzahlVerarbeiteteArtikel == 0)
                    ? (_openBlock(), _createBlock(_component_v_col, {
                        key: 0,
                        class: "pb-2 pl-1",
                        sm: "4"
                      }, {
                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                          _createTextVNode("-")
                        ])),
                        _: 1
                      }))
                    : (!_ctx.vetdataLog.istErfolgreich && _ctx.vetdataLog.anzahlVerarbeiteteArtikel != 0)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 1,
                          class: "pb-2 pl-1",
                          sm: "4"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('vetpointdaten.import.letzterrun') + ' ' + _ctx.vetdataLog.verarbeitetAm + ', ' + _ctx.$t('vetpointdaten.import.status.laufend')), 1)
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_v_col, {
                          key: 2,
                          class: "pb-2 pl-1",
                          sm: "9"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('vetpointdaten.import.letzterrun') +
                        ' ' +
                        _ctx.vetdataLog.verarbeitetAm +
                        ', ' +
                        _ctx.$t('vetpointdaten.import.status.abgeschlossen') +
                        ', ' +
                        _ctx.vetdataLog.fehlerMeldung), 1)
                          ]),
                          _: 1
                        }))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_infinite_scroll, {
                ref: "infiniteScroll",
                onLoad: _ctx.load
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_data_table_server, {
                    "sort-by": _ctx.sortBy,
                    "onUpdate:sortBy": [
                      _cache[2] || (_cache[2] = ($event: any) => ((_ctx.sortBy) = $event)),
                      _ctx.onSortByChanged
                    ],
                    headers: _ctx.headers,
                    items: _ctx.artikelList,
                    loading: _ctx.loading,
                    "item-value": "produktnummer",
                    "items-length": _ctx.totalNumberOfRecords || 0,
                    "hide-default-footer": "",
                    class: "elevation-1 nowhow-table",
                    "must-sort": true,
                    hover: "",
                    "custom-sort": _ctx.customSort
                  }, {
                    top: _withCtx(() => [
                      _createVNode(_component_TableHeader, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.totalNumberOfRecords + ' ' + _ctx.$t('archiv.table.header.items')), 1),
                          (_ctx.showSearchBar)
                            ? (_openBlock(), _createBlock(_component_v_text_field, {
                                key: 0,
                                modelValue: _ctx.filterData.searchQuery,
                                "onUpdate:modelValue": [
                                  _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterData.searchQuery) = $event)),
                                  _ctx.searchFieldInputChanged
                                ],
                                class: "ml-5",
                                "prepend-inner-icon": "mdi-magnify",
                                "append-icon": "mdi-close",
                                label: _ctx.$t('vetpointdaten.suchfeld.title'),
                                "hide-details": "",
                                autofocus: "",
                                "onClick:append": _ctx.searchBarClosed
                              }, null, 8, ["modelValue", "label", "onUpdate:modelValue", "onClick:append"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_spacer),
                          _createVNode(_component_v_tooltip, {
                            top: "",
                            color: "secondary"
                          }, {
                            activator: _withCtx(({ props }) => [
                              _createVNode(_component_v_btn, _mergeProps(props, {
                                icon: "",
                                color: "primary"
                              }), {
                                default: _withCtx(() => [
                                  (!_ctx.showSearchBar)
                                    ? (_openBlock(), _createBlock(_component_v_icon, {
                                        key: 0,
                                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSearchBar = !_ctx.showSearchBar))
                                      }, {
                                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                                          _createTextVNode("mdi-magnify")
                                        ])),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1040)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('tableheader.tooltip.search')), 1)
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    "item.produktnummer": _withCtx(({ item }) => [
                      _createVNode(_component_TextHighlights, {
                        text: item.produktnummer,
                        "search-text": _ctx.filterData.searchQuery
                      }, null, 8, ["text", "search-text"])
                    ]),
                    "item.produktname": _withCtx(({ item }) => [
                      _createVNode(_component_TextHighlights, {
                        text: item.produktname,
                        "search-text": _ctx.filterData.searchQuery
                      }, null, 8, ["text", "search-text"])
                    ]),
                    "item.swissmedicnummer": _withCtx(({ item }) => [
                      _createVNode(_component_TextHighlights, {
                        text: item.swissmedicnummer,
                        "search-text": _ctx.filterData.searchQuery
                      }, null, 8, ["text", "search-text"])
                    ]),
                    "item.atcvetcode": _withCtx(({ item }) => [
                      _createVNode(_component_TextHighlights, {
                        text: item.atcvetcode,
                        "search-text": _ctx.filterData.searchQuery
                      }, null, 8, ["text", "search-text"])
                    ]),
                    _: 1
                  }, 8, ["sort-by", "headers", "items", "loading", "items-length", "custom-sort", "onUpdate:sortBy"])
                ]),
                _: 1
              }, 8, ["onLoad"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}